declare global {
  interface Window {
      __ORDERLY_VERSION__?: {
          [key: string]: string;
      };
  }
}
if (typeof window !== "undefined") {
  window.__ORDERLY_VERSION__ = window.__ORDERLY_VERSION__ || {};
  window.__ORDERLY_VERSION__["@orderly.network/types"] = "3.2.1";
}

export default "3.2.1";
